import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { client } from '@trello/graphql';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyAboutThisBoardModal: FunctionComponent<{
  boardId: string;
}> = ({ boardId }) => {
  const AboutThisBoardModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "about-this-board-modal" */ './AboutThisBoardModal'
      ),
    { preload: false, namedImport: 'AboutThisBoardModal' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'About This Board Modal',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <ApolloProvider client={client}>
            <AboutThisBoardModal boardId={boardId} />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
